var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex mb-0 title__wrapper align-center",
    "class": [_vm.className, {
      'title__wrapper--with-details': _vm.$slots.details,
      'title__wrapper--page': _vm.pageHeader,
      'title__wrapper--scrolled': _vm.scrolled
    }],
    style: _vm.pageHeader ? {
      '--page-header-parent-gap': _vm.pageHeaderGap + 'px'
    } : null
  }, [_c('div', {
    staticClass: "d-flex flex-grow-1 align-center title__lead",
    "class": {
      title__main: _vm.$slots.details
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_vm.back ? _c('v-btn', {
    staticClass: "px-0 b mr-5 white back__button mr-2 d-none d-sm-block",
    attrs: {
      "text": "",
      "small": "",
      "cusor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.back();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.iconName("back")))])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex align-center title__heading"
  }, [_vm.icon ? _c('v-icon', {
    staticClass: "title__icon",
    attrs: {
      "color": "primary",
      "size": _vm.headingHeight
    }
  }, [_vm._v(" " + _vm._s(_vm.iconName(_vm.icon) || _vm.icon) + " ")]) : _vm._e(), _c('div', {
    staticClass: "title__heading-body"
  }, [_c('div', {
    ref: "headingText"
  }, [_c('div', {
    staticClass: "d-flex align-baseline title__heading-row"
  }, [_c('div', {
    staticClass: "title__text mr-2"
  }, [_c('span', {
    staticClass: "title__name"
  }, [_c('MiddleEllipsisText', {
    attrs: {
      "text": _vm.text
    }
  })], 1), _vm.normalizedTags.length ? [_vm._l(_vm.normalizedTags, function (tag) {
    return [tag.tooltip ? _c('v-tooltip', {
      key: "".concat(tag.key, "-tooltip"),
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c('v-chip', _vm._g(_vm._b({
            "class": tag["class"],
            attrs: {
              "ripple": false,
              "color": tag.color,
              "clickable": tag.clickable
            }
          }, 'v-chip', attrs, false), tag.clickable ? Object.assign({}, on, {
            click: function click() {
              return _vm.$emit('tag-click', tag);
            }
          }) : on), [tag.icon ? _c('v-icon', {
            staticClass: "tag-chip__icon",
            attrs: {
              "small": "",
              "color": tag.iconColor,
              "left": !!tag.text
            }
          }, [_vm._v(" " + _vm._s(tag.icon) + " ")]) : _vm._e(), tag.text ? _c('span', {
            staticClass: "tag-chip__text"
          }, [_vm._v(_vm._s(tag.text))]) : _vm._e()], 1)];
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(tag.tooltip))])]) : _c('v-chip', {
      key: tag.key,
      "class": tag["class"],
      attrs: {
        "ripple": false,
        "color": tag.color,
        "clickable": tag.clickable
      },
      on: {
        "click": function click($event) {
          tag.clickable ? _vm.$emit('tag-click', tag) : null;
        }
      }
    }, [tag.icon ? _c('v-icon', {
      staticClass: "tag-chip__icon",
      attrs: {
        "small": "",
        "color": tag.iconColor,
        "left": !!tag.text
      }
    }, [_vm._v(" " + _vm._s(tag.icon) + " ")]) : _vm._e(), tag.text ? _c('span', {
      staticClass: "tag-chip__text"
    }, [_vm._v(_vm._s(tag.text))]) : _vm._e()], 1)];
  })] : _vm._e()], 2)]), _vm.subtitle ? _c('p', {
    staticClass: "title__subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]), _vm.$slots.details ? _c('div', {
    staticClass: "title__details"
  }, [_vm._t("details")], 2) : _vm._e()])], 1)], 1)])]), _vm.reserveActions || _vm.primaryAction || _vm.secondaryGroups.length ? _c('div', {
    staticClass: "title__actions-bar"
  }, [_vm.primaryAction || _vm.secondaryGroups.length ? _c('div', {
    staticClass: "title__split-action"
  }, [_vm.primaryAction ? _c('DisabledTooltipActivator', {
    attrs: {
      "tooltip": _vm.primaryAction.tooltip,
      "wrapper-class": "title__primary-wrap"
    }
  }, [_c('v-btn', {
    staticClass: "title__action-btn",
    "class": {
      'title__action-btn--split': _vm.secondaryGroups.length
    },
    attrs: {
      "color": "primary",
      "elevation": "0",
      "loading": _vm.primaryAction.loading,
      "disabled": !_vm.actionsEnabled || _vm.primaryAction.disabled,
      "title": _vm.primaryAction.label
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.actionClicked(_vm.primaryAction);
      }
    }
  }, [_vm.primaryAction.icon ? _c('v-icon', {
    attrs: {
      "color": "white",
      "small": "",
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.iconName(_vm.primaryAction.icon) || _vm.primaryAction.icon))]) : _vm._e(), _c('span', {
    staticClass: "title__action-label"
  }, [_vm._v(_vm._s(_vm.primaryAction.label))])], 1)], 1) : _vm._e(), _vm.secondaryGroups.length ? _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "content-class": "title__action-menu-content compact-action-menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "title__action-toggle",
          "class": {
            'title__action-toggle--only': !_vm.primaryAction
          },
          attrs: {
            "color": "primary",
            "elevation": "0",
            "disabled": !_vm.actionsEnabled,
            "aria-label": _vm.$translate('otherActions')
          }
        }, 'v-btn', attrs, false), on), [!_vm.primaryAction ? _c('v-icon', {
          attrs: {
            "color": "white",
            "small": "",
            "left": ""
          }
        }, [_vm._v("mdi-menu")]) : _vm._e(), !_vm.primaryAction ? _c('span', {
          staticClass: "title__action-label"
        }, [_vm._v(_vm._s(_vm.$translate('actionsMenu')))]) : _vm._e(), _c('v-icon', {
          attrs: {
            "color": "white",
            "right": !_vm.primaryAction
          }
        }, [_vm._v("mdi-chevron-down")])], 1)];
      }
    }], null, false, 1728054954)
  }, [_c('v-list', {
    staticClass: "title__action-menu"
  }, [_vm._l(_vm.secondaryGroups, function (group, groupIndex) {
    return [groupIndex ? _c('v-divider', {
      key: "divider-".concat(groupIndex)
    }) : _vm._e(), _vm._l(group, function (item, itemIndex) {
      return _c('v-list-item', {
        key: "".concat(groupIndex, "-").concat(itemIndex),
        attrs: {
          "disabled": _vm.isSubmenuItemDisabled(item),
          "title": item.tooltip
        },
        on: {
          "click": function click($event) {
            return _vm.actionClicked(item);
          }
        }
      }, [item.icon ? _c('v-list-item-icon', {
        staticClass: "mr-2 align-self-center"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "color": item.color
        }
      }, [_vm._v(_vm._s(_vm.iconName(item.icon) || item.icon))])], 1) : _vm._e(), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.label))]), item.tooltip ? _c('v-list-item-subtitle', [_vm._v(_vm._s(item.tooltip))]) : _vm._e()], 1), item.loading ? _c('v-progress-circular', {
        attrs: {
          "indeterminate": "",
          "size": "16",
          "width": "2"
        }
      }) : _vm._e()], 1);
    })];
  })], 2)], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }